var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('plan-info',{attrs:{"recurrence":_vm.recurrence,"product":_vm.product,"applied-coupon":_vm.coupon}}),_vm._v(" "),_c('coupon-input',{on:{"coupon-update":_vm.onCouponUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }